import type { SVGProps } from 'react';
export const SvgMoreIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			fill="#AAA"
			d="M4.167 8.334C3.25 8.334 2.5 9.084 2.5 10c0 .917.75 1.667 1.667 1.667.916 0 1.666-.75 1.666-1.667 0-.916-.75-1.666-1.666-1.666M15.833 8.334c-.916 0-1.666.75-1.666 1.666 0 .917.75 1.667 1.666 1.667.917 0 1.667-.75 1.667-1.667 0-.916-.75-1.666-1.667-1.666M10 8.334c-.917 0-1.667.75-1.667 1.666 0 .917.75 1.667 1.667 1.667s1.667-.75 1.667-1.667c0-.916-.75-1.666-1.667-1.666"
		/>
	</svg>
);
